import { StrictMode, createElement } from 'react';
import { createRoot, type Root } from 'react-dom/client';
import { creerControleurNavigateur } from './navigateur.js';
import { Racine } from './Racine.js';

/**
 * Point d’entrée de la coquille. `main.tsx` (propriété de O1, RFC-050) l’appelle : `monterApp(element, { mocks })`.
 * Avec `mocks`, aucune requête ne quitte le navigateur : les réponses viennent des exemples du contrat.
 */
export function monterApp(element: HTMLElement, options: { mocks?: boolean } = {}): Root {
  const mocks = options.mocks ?? false;
  const controleur = creerControleurNavigateur(window, { mocks });
  const racine = createRoot(element);
  racine.render(createElement(StrictMode, null, createElement(Racine, { controleur, donneesExemple: mocks })));
  return racine;
}

export { App } from './App.js';
export { MANIFESTE, TITRE_DOCUMENT, DESCRIPTION_DOCUMENT, genererManifesteJson } from './pwa.js';
